<template>
  <el-form
    ref="addTask"
    :model="addFrom"
    :rules="rules"
    label-width="120px"
    class="reviewer-from"
  >
    <el-row>
      <el-col :span="24">
        <el-form-item label="任务所属部门" prop="bmbh">
          <el-select
            v-model="addFrom.bmbh"
            filterable
            default-first-option
            style="width: 100%"
            placeholder="请选择任务所属部门"
            disabled
          >
            <el-option
              v-for="(item, index) in bmList"
              :key="index"
              :label="item.bmmc"
              :value="item.bmbh"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="任务所属条线" prop="txlx">
          <el-select
            v-model="addFrom.txlx"
            filterable
            default-first-option
            style="width: 100%"
            placeholder="请选择任务所属条线"
            @change="handleChangeLx(addFrom.bmbh, addFrom.txlx)"
          >
            <el-option
              v-for="(item, index) in ygtxoptions"
              :key="index"
              :label="item.value"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="任务类型" prop="name">
          <el-select
            v-model="addFrom.name"
            filterable
            default-first-option
            style="width: 100%"
            placeholder="请选择任务类型"
            @change="handleChangeZl"
          >
            <el-option
              v-for="(item, index) in lxList"
              :key="index"
              :label="item.value"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24" v-if="zlList && zlList.length > 0">
        <el-row>
          <el-col :span="24">
            <el-form-item label="子类" prop="sun">
              <el-select
                ref="sun"
                v-model="addFrom.sun"
                placeholder="请选择子类"
                clearable
                filterable
                size="small"
                style="width: 100%"
                class="filter-item"
              >
                <el-option
                  v-for="item in zlList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="24">
        <el-form-item label="节点名称" prop="jdlx">
          <el-select
            v-model="addFrom.jdlx"
            filterable
            default-first-option
            style="width: 100%"
            placeholder="请选择节点名称"
            @change="handleChangeJdlx"
          >
            <el-option
              v-for="(item, index) in jdlxList"
              :key="index"
              :label="item.jdlxmc"
              :value="item.jdlx"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24" style="position: relative">
        <span class="star">*</span>
        <el-form-item label="审核人" prop="shr">
          <div class="table">
            <div class="table-header">
              <div>审核序号</div>
              <div>审核人</div>
              <div>审核人岗位</div>
              <div>
                操作
                <div
                  @click="handleAddTd"
                  v-if="shrList.length < 1 || addFrom.jdlx != 1"
                >
                  +
                </div>
              </div>
            </div>
            <div class="table-body" v-if="shrList && shrList.length > 0">
              <div
                class="table-tr"
                v-for="(item, index) in shrList"
                :key="index"
              >
                <div class="table-td">{{ index + 1 }}</div>
                <div class="table-td">
                  <treeselect
                    v-model="item.ygbh"
                    placeholder="请选择"
                    :options="deptUser"
                    :disable-branch-nodes="true"
                    :show-count="true"
                    value-consists-of="LEAF_PRIORITY"
                    no-results-text="未搜到任何结果"
                    :clear-on-select="true"
                    :normalizer="normalizer"
                    style="width: 200px"
                    size="small"
                    @select="handleSelectYg"
                  />
                </div>
                <div class="table-td">{{ item.gwmc }}</div>
                <div class="table-td del" @click="handleDelTd(item.id)">
                  删除
                </div>
              </div>
            </div>
            <div v-else class="table-none">暂无数据</div>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="备注" prop="bz">
          <el-input
            type="textarea"
            :autosize="{ minRows: 6, maxRows: 6 }"
            maxlength="200"
            placeholder="请输入备注"
            v-model="addFrom.bz"
          />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
import {
  getBmxxList,
  getKeyValue,
  getTaskZlList,
  getTasklxList,
} from "@/api/taskType.js";
import { saveReviewer, getJdlxSelector } from "@/api/reviewer.js";
import { deepClone } from "../../utils/utils";
export default {
  name: "add",
  computed: {
    ...mapGetters(["deptUser", "user"]),
  },
  components: { Treeselect },
  props: ["mxParams"],
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      addFrom: {
        txlx: null,
        jdlx: null,
        txlx: null,
        name: null,
        sun: null,
        bmbh: null,
        id: null,
        bz: null,
      },
      rules: {
        bmbh: [
          { required: true, message: "任务所属部门不能为空", trigger: "blur" },
        ],
        sun: [{ required: true, message: "子类不能为空", trigger: "blur" }],
        name: [
          { required: true, message: "任务类型不能为空", trigger: "blur" },
        ],
        txlx: [
          {
            required: true,
            message: "任务所属条线不能为空",
            trigger: "blur",
          },
        ],

        jdlx: [
          {
            required: true,
            message: "节点名称不能为空",
            trigger: "blur",
          },
        ],
      },
      bmList: [],
      lxList: [],
      jdlxList: [],
      zlList: [],
      ygtxoptions: [],
      shrList: [],
      parentDialog: false,
      jsjdlxList: [],
      alljdlxList: [],
    };
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    this.addFrom.bmbh = this.user.bmbh;
    // this.addFrom.txlx = this.user.tx;
    this.handleChangeLx(this.addFrom.bmbh, this.addFrom.txlx);
    getBmxxList("0").then((res) => {
      if (res.code == 0) {
        this.bmList = res.data;
      }
    });

    getKeyValue("TXLX", "", "1").then((res) => {
      if (res.code === 0) {
        this.ygtxoptions = res.data;
      }
    });

    getJdlxSelector().then((res) => {
      if (res.code == 0) {
        this.jdlxList = res.data.jdlxList;
        this.jsjdlxList = [deepClone(this.jdlxList)[0]]; //技术的节点类型
        this.alljdlxList = deepClone(this.jdlxList);
      }
    });
  },
  methods: {
    handleChangeRlsh(e) {
      this.addFrom.isReview = e;
    },
    handleChangeDrel(e) {
      this.addFrom.isMultiple = e;
    },
    handleAdd() {
      let reviewer = [];
      if (this.shrList.length == 0) {
        this.$message({
          message: "审核人不能为空",
          type: "error",
        });
      }
      for (let i of this.shrList) {
        if (i.ygbh) {
          reviewer.push(i.ygbh);
        } else {
          this.$message({
            message: "审核人不能为空",
            type: "error",
          });
          return;
        }
      }
      reviewer = reviewer.toString();
      const params = { ...this.addFrom, reviewer };
      saveReviewer(params).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: "保存成功",
            type: "success",
          });
          this.$emit("giveFather", this.parentDialog);
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    giveFather() {
      this.parentDialog = false;
    },
    handleAddTd() {
      const len = this.shrList.length;
      if (len == 0) {
        this.shrList.push({ id: 1, ygbh: null, gwmc: null });
      } else {
        this.shrList.push({
          id: this.shrList[len - 1].id + 1,
          ygbh: null,
          gwmc: null,
        });
      }
    },
    handleDelTd(id) {
      const temp = [];
      for (let i of this.shrList) {
        if (i.id != id) {
          temp.push(i);
        }
      }
      this.shrList = temp;
    },
    handleSelectYg(e) {
      // this.shrList
      setTimeout(() => {
        for (let i in this.shrList) {
          if (this.shrList[i].ygbh == e.ygbh) {
            this.shrList[i].gwmc = e.gwmc;
          }
        }
      }, 50);
    },
    handleChangeZl() {
      getTaskZlList(
        this.addFrom.name,
        this.addFrom.bmbh,
        this.addFrom.txlx
      ).then((res) => {
        if (res.code == 0) {
          this.zlList = res.data;
          this.addFrom.jdlx = null;
          this.addFrom.sun = null;
        }
      });
    },
    handleChangeLx() {
      getTasklxList(this.addFrom.bmbh, this.addFrom.txlx).then((res) => {
        if (res.code == 0) {
          if (this.addFrom.txlx == "1") {
            this.jdlxList = this.jsjdlxList;
          } else {
            this.jdlxList = this.alljdlxList;
          }
          this.lxList = res.data;
          this.addFrom.jdlx = null;
          this.addFrom.sun = null;
        }
      });
    },
    handleChangeJdlx(e) {
      if (e == 1 && this.shrList.length > 1) {
        let temp = this.shrList[0];
        this.shrList = [];
        this.shrList.push(temp);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.star {
  position: absolute;
  top: 13px;
  color: #f56c6c;
  left: 55px;
}
.table {
  .table-header {
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #f2f2f2;
    display: flex;
    justify-content: center;
    > div {
      width: 20%;
      display: flex;
      justify-content: center;
      > div {
        color: #036eb8;
        padding: 0 10px;
        font-size: 25px;
        cursor: pointer;
      }
    }
    > div:nth-of-type(2) {
      width: 40%;
    }
  }
  .table-none {
    text-align: center;
    color: #999;
    margin: 10px 0;
  }
  .table-body {
    .table-tr {
      display: flex;
      height: 44px;
      line-height: 44px;
      text-align: center;
      display: flex;
      justify-content: center;
      border-bottom: 1px solid #f2f2f2;
      // border-left: 1px solid #f2f2f2;
      .table-td {
        display: flex;
        justify-content: center;
        width: 20%;
        // border-right: 1px solid #f2f2f2;
      }
      .table-td:nth-of-type(2) {
        width: 40%;
      }
      .del {
        color: #ff0000;
        cursor: pointer;
      }
    }
  }
}
</style>